// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var Extauth2ChangePasswordStatus;
(function (Extauth2ChangePasswordStatus) {
    Extauth2ChangePasswordStatus[Extauth2ChangePasswordStatus["Success"] = 0] = "Success";
    Extauth2ChangePasswordStatus[Extauth2ChangePasswordStatus["Failed"] = 1] = "Failed";
})(Extauth2ChangePasswordStatus || (Extauth2ChangePasswordStatus = {}));
//# sourceMappingURL=extauth2ChangePasswordStatus.js.map